import React from 'react';
import Colortheme from '../../Theme/Colortheme';

class HorizontalLineText extends React.Component {

    constructor(props) {
        super(props);
        this.style = {
            divStyle: {
                display: 'flex',
                flexDirection: 'row',
                margin: props.margin ?? '0px'
            },
            hr: {
                flex: 4,
                height: '1px',
                backgroundColor: Colortheme.hintColor,
                border: '0px'
            },
            text: {
                color: props.color ?? Colortheme.hintColor,
                flex: 1
            }
        };
    }

    render() {
        return (
            <div style={this.style.divStyle} >
                <hr style={this.style.hr}></hr>
                <div style={this.style.text} align="center">{this.props.children}</div>
                <hr style={this.style.hr}></hr>
            </div>
        );
    }
}

export default HorizontalLineText;